import Menu from './Menu';

export default Menu;



// WEBPACK FOOTER //
// ./src/components/common/Menu/index.js